import { makeStyles } from 'tss-react/mui';

const flexBox = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    flex: 1
} as const;

export default makeStyles()((theme) => ({
    root: {
        ...flexBox,
        gap: 32
    },
    error: {
        margin: 0,
        fontSize: 14,
        color: 'red',
        textAlign: 'center',
        width: '100%'
    },
    loader: {
        width: '80%',
        margin: 'auto',
        borderRadius: 2
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main
    },
    textsContainer: {
        ...flexBox,
        color: '#282D31',
        gap: 8,
        '& *': {
            margin: 0
        }
    },
    fieldsContainer: {
        ...flexBox,
        gap: 24
    },
    buttonsContainer: {
        ...flexBox,
        gap: 16
    },
    submitButton: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: '16px',
        background: '#282D31',
        color: '#FFFFFF',
        boxShadow: 'none !important',
        padding: '20px 56px',
        borderRadius: 18,
        '&:hover': {
            background: '#4D4D4D'
        },
        '&:focus': {
            background: '#4D4D4D'
        },
        '&:active': {
            background: '#000000'
        }
    }
}));
